import { render, staticRenderFns } from "./type_activity_1.vue?vue&type=template&id=2d340b0a"
import script from "./type_activity_1.vue?vue&type=script&lang=js"
export * from "./type_activity_1.vue?vue&type=script&lang=js"
import style0 from "./type_activity_1.vue?vue&type=style&index=0&id=2d340b0a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports